import { ColumnFilterElementTemplateOptions } from 'primereact/column'
import {
  Dropdown,
  DropdownChangeEvent,
  DropdownProps,
} from 'primereact/dropdown'

import i18n from '../../../../../../utils/i18n'
import { EInvoiceHistoryStatus } from '../../../data/model'
import { StatusTag } from './StatusTag'

export const statusFilterTemplate = (
  options: ColumnFilterElementTemplateOptions,
) => {
  if (!options) return null

  const status: EInvoiceHistoryStatus[] = [EInvoiceHistoryStatus.Submitted]

  const valueTemplate = (option: any, props: DropdownProps) => {
    if (option !== null && option !== undefined) {
      return <StatusTag status={option} />
    }

    return <>{props.placeholder}</>
  }

  const itemTemplate = (option: any) => {
    return <StatusTag status={option} />
  }

  return (
    <Dropdown
      value={options.value}
      options={status}
      onChange={(e: DropdownChangeEvent) =>
        options.filterCallback(e.value, options.index)
      }
      valueTemplate={valueTemplate}
      itemTemplate={itemTemplate}
      className="p-column-filter"
      placeholder={i18n.t(
        'eInvoiceHistory.table.columns.status.filterPlaceholder',
      )}
    />
  )
}
